import { Injectable } from '@angular/core';
import { ErrorType } from '@shared-libs/enums';
import { translate } from '@shared-libs/helpers';
import { ErrorService } from './error.service';

/**
 * The file service to handle files across the application
 */
@Injectable({
	providedIn: 'root',
})
export class FileService {
	constructor(private readonly errorService: ErrorService) {}

	/**
	 * Convert a File to an image as [base64, filename]
	 * @param file The file imported
	 * @returns an image as [base64, filename]
	 */
	public convertToImage(file: File): Promise<[string, string]> {
		return new Promise((resolve, reject) => {
			if (!file.type.match(/image.*/)) {
				this.errorService.showApplicationError(
					translate('VALIDATION_ERRORS.FILE.NOT_AN_IMAGE'),
					ErrorType.Validation
				);
				reject();
			}
			if (file.size > 1000000) {
				this.errorService.showApplicationError(
					translate('VALIDATION_ERRORS.FILE.TO_BIG_MB'),
					ErrorType.Validation
				);
				reject();
			}
			const fileReader = new FileReader();
			fileReader.onloadend = (e) => {
				const result = (e.target as FileReader).result as string;
				const base64 = `data:image/jpeg;base64,${result.split(',')[1]}`;
				resolve([base64, file.name]);
			};
			fileReader.readAsDataURL(file);
		});
	}
}
